import React from 'react';
import { paymentLogRows } from '../../data/gtbankUatData';
import { UatPageShell, UatTable } from './UatDocumentationPage';

const columns = [
  { key: 'refNo', label: 'Ref No' },
  { key: 'customerName', label: 'Customer Name' },
  { key: 'customerEmail', label: 'Customer Email' },
  { key: 'service', label: 'Service' },
  { key: 'amount', label: 'Amount' },
  { key: 'currency', label: 'Currency' },
  { key: 'status', label: 'Status' },
  { key: 'gatewayTransactionId', label: 'Gateway Transaction ID' },
  { key: 'createdDate', label: 'Created Date' },
  { key: 'updatedDate', label: 'Updated Date' },
];

export default function AdminPaymentsPage() {
  return (
    <UatPageShell
      title="Admin Payment Logs"
      breadcrumb="Admin Payments"
      heading="Admin Transaction Attempts"
      subtitle="Sample transaction attempts for GTBank MPGS UAT documentation"
    >
      <UatTable columns={columns} rows={paymentLogRows} />
    </UatPageShell>
  );
}
